import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'formatAnswer',
    standalone: false
})
export class FormatAnswerPipe implements PipeTransform {

	constructor(private sanitizer: DomSanitizer) {}

	transform(rawText: string | undefined): SafeHtml {
		const formattedHtml = this.formatAnswerAsHtml(rawText);
		return this.sanitizer.bypassSecurityTrustHtml(formattedHtml);
	}

	formatAnswerAsHtml(answerText: string | undefined) {
		if (!answerText || typeof answerText !== 'string') {
			return '';
		}

		let htmlOutput = '';
		const lines = answerText.split('\n');
		let inList = false;

		for (const line of lines) {
			const trimmedLine = line.trim();

			if (inList && !trimmedLine.startsWith('* ')) {
				htmlOutput += '</ul>';
				inList = false;
			}
			
			if (trimmedLine === '') {
					continue;
			}

			if (trimmedLine.startsWith('* ')) {
				if (!inList) {
					htmlOutput += '<ul>';
					inList = true;
				}
				const listItemContent = trimmedLine.substring(2).trim();
				const processedContent = listItemContent.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
				htmlOutput += `<li>${processedContent}</li>`;
			} 
			else {
				const processedParagraph = trimmedLine.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
				htmlOutput += `<p>${processedParagraph}</p>`;
			}
		}

		if (inList) {
			htmlOutput += '</ul>';
		}

		return htmlOutput;
	}
}